/**
 * -6차 「회수」탭 — `/adm/msix` · 제재관리 `/adm/member/penalty` 가 함께 쓴다
 * (블레이드 `adm/includes/msix-recall`, id 접두어 `mrc-`)
 *
 *   위  회원을 고르면 보유중 목록과 예약 상태가 뜬다. 거기서
 *         즉시회수    보유분을 골라 지금 뺏는다          `/adm/ajax/msix/cancel/now`  ← 회수한 만큼 예약도 줄인다
 *         회수예약    앞으로 받을 -6차부터 차감           `/adm/ajax/msix/cancel/wait`
 *         예약분 지금 회수 · 예약취소 (예약이 걸린 회원만)
 *   아래 검색 목록 둘 — [회수 예약] `/cancel/wait/list` · [회수 내역] `/recall/list`
 *         검색칸(회원 · 기간 · 사유)은 둘이 같고, 상태(진행중/완료)는 예약에만 있다
 *
 * 지급은 -6차 관리의 「지급」탭(Give.js)이다. 제재관리에는 회수만 둔다 — 그 화면은 벌을 주는 자리다.
 */
import MsixPaneBase from './PaneBase';
import Util from '../../../Common/Util';

export default class MsixRecall extends MsixPaneBase {
    constructor(opts = {}) {
        super('mrc', opts);
        this.view  = 'wait';    // 아래 목록: wait(회수 예약) | hist(회수 내역)
        this.waitT = null;
        this.histT = null;
    }

    start() {
        if (!this.exists()) return;

        this.bindTargetMember();
        this.bindFilter(() => this.reload());

        this.el('board')
            .on('click', '#mrc-recall',   () => this._recallPicked())
            .on('click', '#mrc-wait-add', () => this._reserve())
            .on('click', '#mrc-wait-now', () => this._recallForWait())
            .on('click', '#mrc-wait-del', () => this._delWait())
            .on('change', '#mrc-all', (e) => {
                this.el('board').find('.mg-chk').prop('checked', e.currentTarget.checked);
                this._syncPicked();
            })
            .on('change', '.mg-chk', () => this._syncPicked())
            .on('click', '.mg-order', (e) => {
                e.stopPropagation();
                $j.F.Admin.Util.openOrderHandle($(e.currentTarget).data('o'));
            });

        this.el('views').on('click', '.btn', (e) => this._switch($(e.currentTarget).data('view')));

        this.el('list').on('click', '.mg-open', (e) => {
            const $b = $(e.currentTarget);
            this.openMember(String($b.data('name') || ''), Util.int($b.data('mb')));
        });
    }

    /** 탭을 열 때마다 — 처음이면 목록을 만들고, 다시 열면 지급탭에서 바뀌었을 수 있으니 새로 읽는다 */
    open() {
        if (!this.waitT) { this._initWait(); return; }
        this.reload();
        if (this.mbNo) this.loadBoard();
    }

    reload() {
        const t = this.view === 'wait' ? this.waitT : this.histT;
        if (t) t.ajax.reload();
    }

    destroy() {
        [this.waitT, this.histT].forEach(t => t && t.destroy());
        this.waitT = this.histT = null;
        this.el('board').off();
        this.el('views').off();
        this.el('list').off();
    }

    /** 원장이 바뀌면 판·목록·페이지 KPI 가 같이 흐트러진다 */
    _after() {
        if (this.mbNo) this.loadBoard();
        [this.waitT, this.histT].forEach(t => t && t.ajax.reload(null, false));
        if (this.onChange) this.onChange();
    }

    // ─────────────────────────────────────────────── 회원 판 (회수)

    /**
     * 보유 목록을 액션보다 **먼저** 둔다. 회수예약은 보유분이 없을 때 쓰는 것이라, 무엇을
     * 가졌는지 보이지 않는 자리에서 개수를 적게 하면 예약과 즉시회수가 뒤바뀐다.
     */
    boardHtml(r) {
        const wait   = r.wait;
        const list   = r.active || [];
        const active = Util.int((r.sum || {}).active_cnt);
        const waitNo = wait ? Util.int(wait.cnt) : 0;

        const waitTail = waitNo > 0
            ? `<span class="ms-badge is-back">회수예약 ${waitNo}개 남음</span>
               ${active > 0 ? `<button type="button" class="btn btn-sm btn-outline-danger py-0" id="mrc-wait-now"
                       title="예약분만큼 지금 보유분에서 회수">예약분 지금 회수</button>` : ''}
               <button type="button" class="btn btn-sm btn-outline-secondary py-0" id="mrc-wait-del">예약취소</button>
               <span class="text-muted" style="font-size:12px">${this.esc(wait.memo || '')}</span>`
            : '';

        const rows = list.map((g) => {
            const nday = Util.int(g.nday);
            return `
            <tr>
                <td class="text-center"><input type="checkbox" class="mg-chk" value="${Util.int(g.num)}"></td>
                <td class="text-center"><span class="ms-badge is-live">${nday > 0 ? `${nday}일차` : '대기중'}</span></td>
                <td class="text-right">${g.current_pt == null
                    ? '<span class="text-muted">-</span>' : this.n(g.current_pt)}</td>
                <td class="text-center">${Util.int(g.ordernum)
                    ? `<a href="javascript:;" class="mg-order" data-o="${Util.int(g.ordernum)}">${Util.int(g.ordernum)}</a>`
                    : '<span class="text-muted">수동지급</span>'}</td>
                <td class="text-center">${this.esc(g.start_date || '')}</td>
                <td class="mg-memo">${this.esc(g.memo || '')}</td>
            </tr>`;
        }).join('');

        const holdBox = list.length
            ? `<table class="table table-bordered table-sm mg-hold mb-2">
                   <thead><tr>
                       <th style="width:34px" class="text-center"><input type="checkbox" id="mrc-all"></th>
                       <th style="width:70px" class="text-center">일차</th>
                       <th style="width:90px" class="text-right">포인트</th>
                       <th style="width:90px" class="text-center">발주오더</th>
                       <th style="width:100px" class="text-center">발급일</th>
                       <th>사유</th>
                   </tr></thead>
                   <tbody>${rows}</tbody>
               </table>`
            : `<div class="alert alert-secondary py-2" style="font-size:12.5px">
                   지금 <b>보유중인 -6차가 없습니다.</b> 회수할 실물이 없으니 <b>회수예약</b>으로 걸어두세요
                   — 자정 배치가 앞으로 받을 -6차부터 차감합니다.</div>`;

        return `
        ${this.whoHtml(r, waitTail)}

        <div class="mg-act mt-3">
            ${holdBox}
            <input type="text" class="form-control form-control-sm mb-2" id="mrc-memo"
                   placeholder="회수·예약 사유 (필수 · 오더번호·정황)">
            <div class="mg-act-btns">
                <button type="button" class="btn btn-danger btn-sm" id="mrc-recall" disabled>선택 회수</button>
                <span class="text-muted" style="font-size:12px">지금 보유분을 뺏습니다 (되돌릴 수 없음)</span>
                <span class="mg-sep"></span>
                <input type="number" class="form-control form-control-sm" id="mrc-wait-cnt" min="1"
                       value="1" style="width:90px" title="예약 개수">
                <button type="button" class="btn btn-warning btn-sm" id="mrc-wait-add">회수예약</button>
                <span class="text-muted" style="font-size:12px">
                    앞으로 받을 -6차부터 차감${waitNo > 0 ? ' · 기존 예약에 <b>더합니다</b>' : ''}
                </span>
            </div>
        </div>`;
    }

    afterBoard() { this._syncPicked(); }

    /** 고른 건수를 회수 버튼에 그대로 적는다 — 몇 건을 뺏는지 누르기 전에 보여야 한다 */
    _syncPicked() {
        const n = this.el('board').find('.mg-chk:checked').length;
        $('#mrc-recall').prop('disabled', !n).text(n ? `선택 ${n}건 회수` : '선택 회수');
    }

    _who() { return (this.board && this.board.member && this.board.member.mem_name) || ''; }

    /** 고른 grant 를 지금 회수 — 예약이 걸려 있으면 서버가 그만큼 예약도 줄인다 */
    _recallPicked() {
        if (!this.mbNo) return;

        const nums = this.el('board').find('.mg-chk:checked').map((i, el) => Util.int(el.value)).get();
        if (!nums.length) return;

        const memo = $.trim($('#mrc-memo').val());
        if (!memo) { $j.F.Admin.Util.tsalert('error', '회수 사유를 입력하세요.'); return $('#mrc-memo').trigger('focus'); }

        const waitNo = this.board && this.board.wait ? Util.int(this.board.wait.cnt) : 0;
        const tail   = waitNo > 0 ? '<br>회수한 만큼 <b>회수예약 개수도 줄어듭니다.</b>' : '';

        Util.swalert(`${this.esc(this.el('mem').val())}<br><br>보유중 <b>${nums.length}건</b>을 지금 회수할까요?
                 되돌릴 수 없습니다.${tail}`, () => {
            $.post('/adm/ajax/msix/cancel/now', { mb_no: this.mbNo, nums, memo })
                .done((r) => this._recallDone(r))
                .fail(() => $j.F.Admin.Util.tsalert('error', '회수 중 오류가 발생했습니다.'));
        }, ['예', '아니오']);
    }

    /** 「예약분 지금 회수」 — 개수는 남은 예약분이다 */
    _recallForWait() {
        const mbNo = this.mbNo;
        const cnt  = this.board && this.board.wait ? Util.int(this.board.wait.cnt) : 0;
        const name = this._who();
        if (!mbNo || cnt < 1) return;

        const memo = `회수예약 즉시집행 — ${name}`;
        Util.swalert(`${this.esc(name)} 님의 <b>회수예약 ${cnt}개</b>를 지금 보유분에서 회수할까요?<br>
                 보유분이 모자라면 남은 개수는 예약으로 남습니다.`, () => {
            $.post('/adm/ajax/msix/cancel/now', { mb_no: mbNo, cnt, memo })
                .done((r) => this._recallDone(r))
                .fail(() => $j.F.Admin.Util.tsalert('error', '회수 중 오류가 발생했습니다.'));
        }, ['예', '아니오']);
    }

    _recallDone(r) {
        if (!r.result) return $j.F.Admin.Util.tsalert('error', r.message || '회수하지 못했습니다.');

        const msg = [`-6차 ${Util.int(r.done)}건을 회수했습니다.`];
        if (Util.int(r.short) > 0)    msg.push(`보유분이 모자라 ${Util.int(r.short)}건은 회수하지 못했습니다.`);
        if (Util.int(r.waitLeft) > 0) msg.push(`남은 예약 ${Util.int(r.waitLeft)}개.`);

        $j.F.Admin.Util.tsalert('success', msg.join(' '));
        this._after();
    }

    /**
     * 회수예약 — **지금 가진 것을 뺏는 것이 아니다.** 자정 배치가 그날 새로 발급된 것부터 차감한다.
     * 재발주 판정에서 보유분이 없을 때 자동으로 걸리는 예약과 같은 자리다.
     */
    _reserve() {
        if (!this.mbNo) return;

        const cnt  = Util.int($('#mrc-wait-cnt').val());
        const memo = $.trim($('#mrc-memo').val());
        if (cnt < 1) { $j.F.Admin.Util.tsalert('error', '예약 개수는 1 이상이어야 합니다.'); return $('#mrc-wait-cnt').trigger('focus'); }
        if (!memo)   { $j.F.Admin.Util.tsalert('error', '예약 사유를 입력하세요.'); return $('#mrc-memo').trigger('focus'); }

        Util.swalert(`${this.esc(this.el('mem').val())}<br><br>앞으로 발급되는 -6차 <b>${cnt}개</b>를 자동 회수하도록 예약할까요?`, () => {
            $.post('/adm/ajax/msix/cancel/wait', { mb_no: this.mbNo, memo, cnt })
                .done((r) => {
                    if (!r.result) return $j.F.Admin.Util.tsalert('error', r.message || '예약하지 못했습니다.');
                    $j.F.Admin.Util.tsalert('success', `예약했습니다. (남은 예약 ${Util.int(r.left)}개)`);
                    this._after();
                })
                .fail(() => $j.F.Admin.Util.tsalert('error', '예약 중 오류가 발생했습니다.'));
        }, ['예', '아니오']);
    }

    _delWait() {
        const mbNo = this.mbNo;
        if (!mbNo) return;

        Util.swalert(`${this.esc(this._who())} 님의 회수 예약을 취소할까요?`, () => {
            $.ajax({ url: '/adm/ajax/msix/cancel/wait', type: 'delete', data: { mb_no: mbNo } })
                .done((r) => {
                    if (!r.result) return $j.F.Admin.Util.tsalert('error', '취소하지 못했습니다.');
                    $j.F.Admin.Util.tsalert('success', '예약을 취소했습니다.');
                    this._after();
                })
                .fail(() => $j.F.Admin.Util.tsalert('error', '취소 중 오류가 발생했습니다.'));
        }, ['예', '아니오']);
    }

    // ─────────────────────────────────────────────── 검색 목록 (회수 예약 | 회수 내역)

    _switch(view) {
        if (!view || view === this.view) return;
        this.view = view;

        this.el('views').find('.btn').removeClass('active').filter(`[data-view="${view}"]`).addClass('active');
        this.el('wait-wrap').prop('hidden', view !== 'wait');
        this.el('hist-wrap').prop('hidden', view !== 'hist');
        // 상태(진행중/완료)는 예약에만 있는 축이다
        this.el('f-state-wrap').toggle(view === 'wait');

        if (view === 'hist' && !this.histT) this._initHist();
        else this.reload();
    }

    /**
     * 회수 예약 — 회원당 한 줄. 개수를 다 회수해도 행은 남는다(`cnt=0`, 사유 이력 보존).
     * 회수·예약취소는 행에 두지 않는다 — 「위에서 열기」로 회원 판을 열고 거기서 한다.
     */
    _initWait() {
        this.waitT = this.dataTable('#mrc-wait-table', '/adm/ajax/msix/cancel/wait/list', [
            { data: 'created_at', title: '예약일시', width: '120px', className: 'text-center',
              render: (v) => this.nowrap(String(v || '').slice(0, 16)) },
            { data: null, title: '회원', width: '150px',
              render: (d) => `${this.memCell(d)}<br>${this.openBtn(d)}` },
            { data: 'cnt', title: '남은 예약', width: '100px', className: 'text-center',
              render: (v) => Util.int(v) > 0
                  ? `<span class="badge badge-warning"><b>${Util.int(v)}</b>개 남음</span>`
                  : '<span class="badge badge-secondary">회수 완료</span>' },
            { data: 'active_cnt', title: '현재 보유', width: '80px', className: 'text-center',
              render: (v) => Util.int(v) > 0 ? `<span class="ms-badge is-live">${Util.int(v)}건</span>` : '<span class="text-muted">-</span>' },
            { data: 'manage_name', title: '등록자', width: '80px', className: 'text-center',
              render: (v) => this.nowrap(v) || '<span class="text-muted">시스템</span>' },
            { data: 'memo', title: '사유', className: 'mg-memo',
              render: (v) => this.esc(v) || '<span class="text-muted">사유 미기재</span>' },
        ], {
            createdRow: (tr, d) => { if (Util.int(d.cnt) <= 0) $(tr).addClass('mg-wait-done'); },
        });
    }

    /** 회수 내역 — 관리자회수로 닫힌 -6차 한 건 = 한 줄 (즉시회수·예약 자정집행·내역탭 회수 모두) */
    _initHist() {
        this.histT = this.dataTable('#mrc-hist-table', '/adm/ajax/msix/recall/list', [
            { data: 'used_date', title: '회수일시', width: '120px', className: 'text-center',
              render: (v) => this.nowrap(String(v || '').slice(0, 16)) },
            { data: null, title: '회원', width: '150px',
              render: (d) => `${this.memCell(d)}<br>${this.openBtn(d)}` },
            { data: 'ordernum', title: '발주오더', width: '90px', className: 'text-center',
              render: (v) => Util.int(v) ? Util.int(v) : '<span class="text-muted">수동지급</span>' },
            { data: 'nday', title: '회수 당시', width: '90px', className: 'text-center',
              render: (v) => Util.int(v) > 0 ? `${Util.int(v)}일차` : '대기중' },
            { data: 'manage_name', title: '처리자', width: '80px', className: 'text-center',
              render: (v) => this.nowrap(v) || '<span class="text-muted">시스템</span>' },
            { data: 'memo', title: '사유', className: 'mg-memo', render: (v) => this.esc(v || '') },
        ]);
    }
}
